// extracted by mini-css-extract-plugin
module.exports = {"bannerParent":"Banner_bannerParent__In6rJ","subheading":"Banner_subheading__j0grx"};